import { FormattedMessage as FM } from "react-intl";

import ColForm from "componentsv2/form/ColForm";
import { cn } from "tools/ui";
import { theme } from "theme/theme";

function FormField({ label, colspan, name, required, children, model, mode }) {
  let labelFull = label;
  // console.log("modelo....", model, name);
  if (model) {
    labelFull = `${model}.${label}`;
  }
  return (
    <ColForm colspan={colspan}>
      {label && (
        <span
          className={cn(
            "flex mt-2 mb-0.5 ml-1 max-h-5 text-sm",
            mode === "dark" ? theme.textLabelColorDark : theme.textLabelColor,
          )}
          htmlFor={name}
        >
          <FM id={label} key={labelFull} />
          {required?.value && (
            <p className="font-bold text-sm text-rose-500">&nbsp; *</p>
          )}
        </span>
      )}
      {children}
    </ColForm>
  );
}

export default FormField;
